module.exports = __webpack_public_path__ + "static/media/icon-recom.96051c32.png";